import api, { request } from '../../../../api';
import { IStore } from '../../../index';
import { IAdminFlight } from '../../eventFlights/store';

export const editFlight = async (state: IStore, clubId: number, flight: IAdminFlight) => {
  const response = await request.patch(
    `${api.admin.flights(clubId, flight.event)}${flight.id}/`,
    flight
  );

  if (response.error) {
    const err =
      (response.error.statusText && response.error.statusText.join('. ')) || response.error.status;
    return { errors: { events: { msg: 'Error editing the flight: ' + err } } };
  }

  const newFlights = state.adminEvents[response.event].flights.map((f: IAdminFlight) =>
    f.id === response.id ? response : f
  );

  return {
    adminEvents: {
      all: {
        ...state.adminEvents.all,
        [response.event]: {
          ...state.adminEvents[response.event],
          flights: newFlights
        }
      },
      current: {
        ...state.adminEvents[response.event],
        flights: newFlights
      },
      [response.event]: {
        ...state.adminEvents[response.event],
        flights: newFlights
      }
    }
  };
};
